<script setup>
import NavbarItem from '@/components/Navbar/NavbarItem.vue';
</script>

<template>
  <component :is='layoutComponent'>
    <template
      v-for='item in items'
      :key='item.name'
    >
      <NavbarItem
        v-if='!item.hide'
        v-model:hover-item='localHoverItem'
        :is-mobile='isMobile'
        :item='item'
        :only-icon='onlyIcon'
        @click-on-item='clickOnItem'
      />
    </template>
  </component>
</template>

<script>
import { HRow, HCol } from '@pixul/hephaestus';

export default {
  name : 'NavbarList',

  components : {
    HRow,
    HCol
  },

  props : {
    items : {
      type     : Array,
      required : true
    },

    hoverItem : {
      type    : String,
      default : null
    },

    isMobile : {
      type    : Boolean,
      default : false
    },

    onlyIcon : {
      type    : Boolean,
      default : false
    }
  },

  emits : ['update:hoverItem', 'clickOnItem'],

  data() {

    return {
      localHoverItem : null
    };
  },

  computed : {
    layoutComponent() {

      if (this.isMobile) {

        return 'HCol';
      }

      return 'HRow';
    }
  },

  watch : {
    items() {

      this.localHoverItem = this.hoverItem;
    },

    localHoverItem() {

      this.$emit('update:hoverItem', this.localHoverItem);
    }
  },

  created() {

    this.localHoverItem = this.hoverItem;
  },

  methods : {
    clickOnItem() {

      this.$emit('clickOnItem');
    }
  }
};
</script>

